import React from "react";

export const MediumInfo = ({ size = 16 }: { size?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_4868_5053)">
      <path
        d="M8 16C6.41775 16 4.87104 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346629 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346629 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87104 16 6.41775 16 8C15.9977 10.121 15.1541 12.1545 13.6543 13.6543C12.1545 15.1541 10.121 15.9977 8 16ZM8 1.33334C6.68146 1.33334 5.39253 1.72433 4.2962 2.45687C3.19987 3.18942 2.34539 4.23061 1.84081 5.44878C1.33622 6.66695 1.2042 8.0074 1.46144 9.30061C1.71867 10.5938 2.35361 11.7817 3.28596 12.714C4.21831 13.6464 5.4062 14.2813 6.6994 14.5386C7.99261 14.7958 9.33305 14.6638 10.5512 14.1592C11.7694 13.6546 12.8106 12.8001 13.5431 11.7038C14.2757 10.6075 14.6667 9.31855 14.6667 8C14.6647 6.23249 13.9617 4.53792 12.7119 3.2881C11.4621 2.03828 9.76752 1.33528 8 1.33334Z"
        fill="currentColor"
      />
      <path
        d="M9.33329 12.6666H7.99996V7.99996H6.66663V6.66663H7.99996C8.35358 6.66663 8.69272 6.8071 8.94277 7.05715C9.19282 7.3072 9.33329 7.64634 9.33329 7.99996V12.6666Z"
        fill="currentColor"
      />
      <path
        d="M8 5.33337C8.55228 5.33337 9 4.88566 9 4.33337C9 3.78109 8.55228 3.33337 8 3.33337C7.44772 3.33337 7 3.78109 7 4.33337C7 4.88566 7.44772 5.33337 8 5.33337Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4868_5053">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
